var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-header" },
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            top: "",
            center: "",
            timeout: 10000,
            color: _vm.snackbarColor
          },
          model: {
            value: _vm.showSnackbarMessage,
            callback: function($$v) {
              _vm.showSnackbarMessage = $$v
            },
            expression: "showSnackbarMessage"
          }
        },
        [
          _c("v-icon", { attrs: { dark: "" } }, [_vm._v("warning")]),
          _vm._v("   \n        "),
          _c("span", {
            domProps: { textContent: _vm._s(_vm.snackbarMessage) }
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "black--text snackbar-button",
              attrs: { color: _vm.snackbarColor },
              on: {
                click: function($event) {
                  _vm.snackbarMessage = null
                  _vm.showSnackbarMessage = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "header",
        [
          _vm.fromapp != "ida"
            ? [
                _c("div", { staticClass: "brand" }, [
                  _c("div", {}, [
                    (_vm.isSuperAdmin || _vm.isSuperUser) && _vm.showTenantIcon
                      ? _c("div", {
                          staticClass: "logo logocolor",
                          attrs: {
                            src: "../assets/images/logo_4iqBlack.svg",
                            alt: "4IQ Logo"
                          },
                          on: {
                            click: function($event) {
                              return _vm.backToTenants()
                            }
                          }
                        })
                      : _c("div", {
                          staticClass: "logocolor",
                          attrs: {
                            src: "../assets/images/logo_4iqBlack.svg",
                            alt: "4IQ Logo"
                          }
                        })
                  ]),
                  _vm._v(" "),
                  _vm.docsview
                    ? _c("div", { staticClass: "logodiv" }, [_vm._m(0)])
                    : _vm.showTenantIcon && _vm.fromapp != "bd"
                    ? _c("div", { staticClass: "logodiv" }, [
                        _c(
                          "b",
                          {
                            staticClass: "tenant-name",
                            on: {
                              click: function($event) {
                                _vm.pagename != "noAppNoDoc"
                                  ? _vm.backToAppsPage()
                                  : ""
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.tenantName))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fromapp == "bd"
                    ? _c("div", { staticClass: "tenant-logo logodiv" }, [
                        _c("span", { staticClass: "app-title" }, [
                          _vm._v("Alert Dashboard")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "app-title beta-version" }, [
                          _vm._v("Beta")
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "navbar-center" }, [
                  _c(
                    "ul",
                    { staticClass: "apps-menu" },
                    _vm._l(_vm.availableApps, function(value, key) {
                      return _c(
                        "li",
                        {
                          key: key,
                          staticClass: "apps",
                          class: _vm.activeApp == key ? "active" : "",
                          on: {
                            click: function($event) {
                              return _vm.switchApp(key)
                            }
                          }
                        },
                        [_c("a", { domProps: { textContent: _vm._s(value) } })]
                      )
                    }),
                    0
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class:
                _vm.fromapp != "ida"
                  ? "header-icon-options-div"
                  : "ida-header header-icon-options-div"
            },
            [
              _c(
                "div",
                { staticClass: "header-icons-div" },
                [
                  _vm.fromapp == "ep"
                    ? _c("img", {
                        staticClass: "user-icon app-icons",
                        attrs: {
                          src: require("../assets/images/user-menu-icon-white.svg")
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeSettings()
                          }
                        }
                      })
                    : _c(
                        "v-icon",
                        {
                          attrs: { title: "User Menu" },
                          on: {
                            click: function($event) {
                              return _vm.closeSettings()
                            }
                          }
                        },
                        [_vm._v("account_circle")]
                      )
                ],
                1
              ),
              _vm._v(" "),
              _vm.appsInfo &&
              _vm.appsInfo.length > 1 &&
              _vm.isSuperAdmin == false
                ? _c(
                    "div",
                    { staticClass: "header-icons-div" },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: { title: "Apps" },
                          on: {
                            click: function($event) {
                              _vm.showAppsPanel = !_vm.showAppsPanel
                              _vm.showSettings = false
                              _vm.showProfileSettings = _vm.showAdminSettings = false
                            }
                          }
                        },
                        [_vm._v("apps")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCurrentAppInfo["app_doc"]
                ? _c(
                    "div",
                    { staticClass: "header-icons-div" },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: { title: "Help Docs" },
                          on: {
                            click: function($event) {
                              return _vm.launchDocPage()
                            }
                          }
                        },
                        [_vm._v("help_outline")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.fromapp != "ug" &&
              (_vm.enableAppsPage ||
                _vm.isSuperAdmin ||
                _vm.isAppAdmin ||
                _vm.isTenantAdmin)
                ? _c(
                    "div",
                    { staticClass: "header-icons-div" },
                    [
                      _vm.showTenantIcon && _vm.fromapp == "bd"
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "tenant-logo remove-border",
                                on: {
                                  click: function($event) {
                                    _vm.pagename != "noAppNoDoc"
                                      ? _vm.backToAppsPage()
                                      : ""
                                  }
                                }
                              },
                              [_c("b", [_vm._v(_vm._s(_vm.tenantName))])]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.showSettings
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.away,
                      expression: "away"
                    }
                  ],
                  staticClass: "user-settings-div"
                },
                [
                  _c("div", { staticClass: "user-settings" }, [
                    _c("div", { staticClass: "user-info-div" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-info" }, [
                        _c("h6", { staticClass: "user-name" }, [
                          _vm._v(
                            _vm._s(_vm.userInfo["username"]) +
                              "@" +
                              _vm._s(_vm.userInfo["domain"])
                          )
                        ]),
                        _vm._v(" "),
                        _vm.fromapp == "bd"
                          ? _c("div", { staticClass: "user-role" }, [
                              _c("span", { staticClass: "userrole-span" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSuperAdmin
                                      ? "Super Admin"
                                      : _vm.isEditor
                                      ? "Editor"
                                      : "User"
                                  )
                                )
                              ])
                            ])
                          : _c("div", { staticClass: "user-role" }, [
                              _c("span", { staticClass: "userrole-span" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSuperAdmin ? "Super Admin" : "User"
                                  )
                                )
                              ])
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-settings-menu" }, [
                      _c(
                        "ul",
                        [
                          _c(
                            "li",
                            {
                              class: _vm.showProfileSettings ? "active" : "",
                              on: {
                                click: function($event) {
                                  _vm.showProfileSettings = !_vm.showProfileSettings
                                  _vm.showAdminSettings = false
                                }
                              }
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-icon item-icon-right" },
                                [
                                  !_vm.showProfileSettings
                                    ? _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [
                                          _vm._v(
                                            "\n                                keyboard_arrow_down"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("keyboard_arrow_up")]
                                      )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showProfileSettings
                            ? [
                                _vm.userInfo["has_2fa"]
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "sub-user-settings-menu",
                                        on: {
                                          click: function($event) {
                                            _vm.showSettings = false
                                            _vm.showModal = true
                                          }
                                        }
                                      },
                                      [_vm._m(4), _vm._v(" "), _vm._m(5)]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "sub-user-settings-menu sub-user-settings-menu-last",
                                    class: _vm.userInfo["sso_user"]
                                      ? "disabled"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        _vm.showSettings = false
                                        _vm.showPasswordModal = true
                                      }
                                    }
                                  },
                                  [_vm._m(6), _vm._v(" "), _vm._m(7)]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.fromapp == "ida"
                            ? [
                                _vm.isSuperAdmin ||
                                _vm.enableBOUI ||
                                _vm.enableCheckerUI
                                  ? _c(
                                      "li",
                                      {
                                        class: _vm.showAdminSettings
                                          ? "active"
                                          : "",
                                        on: {
                                          click: function($event) {
                                            _vm.showAdminSettings = !_vm.showAdminSettings
                                            _vm.showProfileSettings = _vm.showExploreToSettings = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(8),
                                        _vm._v(" "),
                                        _vm._m(9),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-icon item-icon-right"
                                          },
                                          [
                                            !_vm.showAdminSettings
                                              ? _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    keyboard_arrow_down"
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons"
                                                  },
                                                  [_vm._v("keyboard_arrow_up")]
                                                )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAdminSettings
                                  ? [
                                      _vm.enableBOUI || _vm.isSuperAdmin
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "sub-user-settings-menu",
                                              on: {
                                                click: function($event) {
                                                  return _vm.launchIDAApp("bo")
                                                }
                                              }
                                            },
                                            [
                                              _vm._m(10),
                                              _vm._v(" "),
                                              _vm._m(11)
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.enableCheckerUI || _vm.isSuperAdmin
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "sub-user-settings-menu sub-user-settings-menu-last",
                                              on: {
                                                click: function($event) {
                                                  return _vm.launchIDAApp(
                                                    "checker"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._m(12),
                                              _vm._v(" "),
                                              _vm._m(13)
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSuperAdmin && _vm.showTenantIcon
                            ? _c(
                                "li",
                                {
                                  attrs: { id: "backToTenants" },
                                  on: {
                                    click: function($event) {
                                      return _vm.backToTenants()
                                    }
                                  }
                                },
                                [_vm._m(14), _vm._v(" "), _vm._m(15)]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.fromapp != "ug" &&
                          (_vm.enableAppsPage ||
                            _vm.isSuperAdmin ||
                            _vm.isAppAdmin ||
                            _vm.isTenantAdmin)
                            ? _c(
                                "li",
                                {
                                  attrs: { id: "backToApps" },
                                  on: {
                                    click: function($event) {
                                      return _vm.backToAppsPage()
                                    }
                                  }
                                },
                                [_vm._m(16), _vm._v(" "), _vm._m(17)]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.enableDocsPage && !_vm.docsview
                            ? _c(
                                "li",
                                {
                                  attrs: { id: "backToDocs" },
                                  on: {
                                    click: function($event) {
                                      return _vm.backToDocsPage()
                                    }
                                  }
                                },
                                [_vm._m(18), _vm._v(" "), _vm._m(19)]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userCurrentAppInfo["app_tnc"]
                            ? _c(
                                "li",
                                {
                                  attrs: { id: "tnc" },
                                  on: {
                                    click: function($event) {
                                      _vm.showSettings = false
                                      _vm.showTnCView = true
                                    }
                                  }
                                },
                                [_vm._m(20), _vm._v(" "), _vm._m(21)]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(22),
                          _vm._v(" "),
                          _vm.fromapp == "bd"
                            ? _c("li", { attrs: { id: "feedback" } }, [
                                _vm._m(23),
                                _vm._v(" "),
                                _vm._m(24)
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              attrs: { id: "logout" },
                              on: { click: _vm.logout }
                            },
                            [_vm._m(25), _vm._v(" "), _vm._m(26)]
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("modalpopupVue", {
            attrs: { dialogStatus: _vm.showModal },
            on: { close: _vm.closePopup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showBackupCodesModal
        ? _c("backupCodesModal", {
            attrs: { fromHeader: true, dialogStatus: _vm.showBackupCodesModal },
            on: {
              close: function($event) {
                _vm.showBackupCodesModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTnCView
        ? _c("app-terms", {
            attrs: {
              session: _vm.accessToken,
              app: _vm.fromapp,
              fromheader: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPasswordModal
        ? _c("changePasswordPopupVue", {
            attrs: { dialogStatus: _vm.showPasswordModal },
            on: {
              close: function($event) {
                _vm.showPasswordModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAppsPanel
        ? _c("appsPanelMenuVue", {
            attrs: { appsInfo: _vm.appsInfo },
            on: {
              close: function($event) {
                _vm.showAppsPanel = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "600" },
          model: {
            value: _vm.showSupport4iQPopup,
            callback: function($$v) {
              _vm.showSupport4iQPopup = $$v
            },
            expression: "showSupport4iQPopup"
          }
        },
        [
          _vm.showSupport4iQPopup
            ? _c("support4iQ", {
                on: {
                  close: function($event) {
                    _vm.showSupport4iQPopup = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tenant-logo" }, [
      _c("b", [_vm._v("Documentations")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "user-icon" }, [
      _c("img", {
        attrs: { src: require("../assets/images/user-menu-icon-white.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("face")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Profile")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("mobile_friendly")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Reset 2FA")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("lock_outline")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Change Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("developer_board")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Admin Tools")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("settings_backup_restore")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Back-Office UI")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("settings_brightness")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Checker UI")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("reply")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Back to Tenants")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("reply_all")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Back to Apps")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("help_outline")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Constella Docs Home")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("playlist_add_check")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Terms of use")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { attrs: { id: "support4iQ" } }, [
      _c("div", { staticClass: "item-icon" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("build")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-name" }, [
        _c("span", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support",
                target: "new"
              }
            },
            [_vm._v("Contact Constella Support")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("feedback")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://4iqnet.atlassian.net/servicedesk/customer/portal/3/group/-1",
              target: "new"
            }
          },
          [_vm._v("Help Center")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("power_settings_new")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("span", [_vm._v("Logout")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }